var _path, _path2, _path3, _path4, _circle, _path5, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWoopsOculus = function SvgWoopsOculus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 34C0 21.8497 9.84974 12 22 12H90C102.15 12 112 21.8497 112 34V78C112 90.1503 102.15 100 90 100H22C9.84974 100 0 90.1503 0 78V34Z",
    fill: "#FFB82D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8 35C8 26.7157 14.7157 20 23 20H89C97.2843 20 104 26.7157 104 35V77C104 85.2843 97.2843 92 89 92H23C14.7157 92 8 85.2843 8 77V35Z",
    fill: "#FFB82D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15 37C15 31.4772 19.4772 27 25 27H87C92.5229 27 97 31.4772 97 37V75C97 80.5228 92.5229 85 87 85H25C19.4772 85 15 80.5228 15 75V37Z",
    fill: "#FFB82D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 38.3333C21 35.3878 23.3878 33 26.3333 33H85.6667C88.6122 33 91 35.3878 91 38.3333V73.6667C91 76.6122 88.6122 79 85.6667 79H26.3333C23.3878 79 21 76.6122 21 73.6667V38.3333Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.3337,
    cy: 36.6667,
    r: 10.6667,
    fill: "url(#woops_oculus_svg__paint0_linear_4364_100744)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.334 32H86.334L86.0007 36.6667H84.6673L84.334 32Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.334,
    cy: 39.6667,
    r: 1,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 50,
    width: 12,
    height: 3,
    fill: "#E9ECEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 64,
    width: 9,
    height: 8,
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 50,
    width: 12,
    height: 3,
    fill: "#E9ECEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 50,
    width: 12,
    height: 3,
    fill: "#E9ECEF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 50,
    width: 12,
    height: 3,
    fill: "#E9ECEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "woops_oculus_svg__paint0_linear_4364_100744",
    x1: 74.7549,
    y1: 25.8494,
    x2: 96.1385,
    y2: 47.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB82D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA057"
  })))));
};
export default SvgWoopsOculus;